import { render, staticRenderFns } from "./xxzy.vue?vue&type=template&id=3f01fc88&scoped=true&"
import script from "./xxzy.vue?vue&type=script&lang=js&"
export * from "./xxzy.vue?vue&type=script&lang=js&"
import style0 from "./xxzy.vue?vue&type=style&index=0&id=3f01fc88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f01fc88",
  null
  
)

export default component.exports